
import { DecimalConfig } from "@/models/dossier-configs/decimal-config";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { UserConfigService } from "@/services/user-config-service";
import {SaleRow} from "@/models/base";
import { printDuration, printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({

	data() {
		return {

		};
	},
	props: {
		isSelected: Boolean,
		row: Object as () => SaleRow,
		rowIndex: {
			type: Number
		},
		widths: {
			type: Object as ()=>{[index:string]:number},
			required: true
		},
		currencyRate: {
			type: Number
		},
		showQty2: Boolean
	},
	computed: {
		decimalSettings():DecimalConfig {
			return DossierConfigService.getDecimalSettings();
		},
		isBold(): boolean {
			return this.row.getRowConfig().Bold;
		},
		isHidden(): boolean {
			return this.row.getRowConfig().Hidden;
		},
		isSubTotal(): boolean {
			return this.row.getRowConfig().SubTotal;
		},
		netto(): number {
			return this.row.UnitPrice * this.row.Amount * (1 - (this.row.Discount / 100));
		},
		leeggoedTax(): number{
			return this.row.LeeggoedTax*this.row.Amount;
		},
		ecoboniTax(): number{
			return this.row.EcoboniTax*this.row.Amount;
		},
		accijnzenTax(): number{
			return this.row.AccijnzenTax*this.row.Amount;
		},
		bruto(): number {
			return (this.netto + this.ecoboniTax + this.accijnzenTax ) * (1 + (this.row.Vat / 100.0)) + this.leeggoedTax  ;
		},
		computedDescription(): string{
			//disabled
			let t =  this.row.ProductDescription;
			t = t.replace(/\*\*\*(.*?)\*\*\*/gm, "<b><i>$1</i></b>");
			t = t.replace(/\*\*(.*?)\*\*/gm, "<b>$1</b>");
			t = t.replace(/\*(.*?)\*/gm, "<i>$1</i>");
			t = t.replace(/__(.*?)__/gm, "<u>$1</u>");
			return t;
		},
		displayedProductDescription():String{
			return this.row.ProductDescription.replaceAll("{__NEW_LINE__}","<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;");
		},
		hideUnits():Boolean {
			return !UserConfigService.getSaleSettings().ShowUnits;
		},
	},
	methods: {
		getWidth(name:string):string{
			if (name == "description") {
				return `calc(100% - ${this.getTotalWidthWithoutDescription()})`;
			}
			return `${this.widths[name]}px`;
		},
		getTotalWidthWithoutDescription():number {
			return Object.keys(this.widths).map((key)=>this.widths[key]).reduce((prevVal, currentVal)=>prevVal+currentVal);
		},
		humanFloat(val:number, decimals:number){
			return printHumanFloat(val, decimals);
		},
		humanDuration(val:number){
			return printDuration(val);
		}
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
